import React from "react";
import {CustomOrAnyQuickLinkText} from "../../../../global/style";

export default function CustomOrAnyQuickLink({text}) {
  return (
    <CustomOrAnyQuickLinkText className="CustomOrAnyQuickLinkText">
      <span>{text}</span>
    </CustomOrAnyQuickLinkText>
  )
}